import { render, staticRenderFns } from "./FormPrivateFiles.vue?vue&type=template&id=d6a68dfa"
import script from "./FormPrivateFiles.vue?vue&type=script&lang=js"
export * from "./FormPrivateFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports